import { all } from 'redux-saga/effects';
import { watchShowPageAsync } from './system/showPageSaga';
import { watchShowPageAction } from '../../utilsTsx/reduxSaga/saga/showPageSaga';

export default function* rootSaga() {
    yield all([
        watchShowPageAsync(),
        watchShowPageAction()
    ]);
}

